import {
  API_ERROR,
  LOGIN_FAIL,
  LOGIN_SUCCESS,
  LOGIN_USER,
  LOGOUT_USER,  
  LOGOUT_USER_SUCCESS,
  SOCIAL_LOGIN
} from "./actionTypes";

export const loginUser = (values, navigate) => ({
  type: LOGIN_USER,
  payload: { values, navigate },
});

export const loginFail = (error) => ({
  type: LOGIN_FAIL,
  payload: error,
});
export const loginSuccess = user => {
  return {
    type: LOGIN_SUCCESS,
    payload: user,
  }
}

export const logoutUser = history => {
  return {
    type: LOGOUT_USER,
    payload: { history },
  }
}

export const logoutUserSuccess = () => {
  return {
    type: LOGOUT_USER_SUCCESS,
    payload: {},
  }
}

export const apiError = error => {
  return {
    type: API_ERROR,
    payload: error,
  }
}

export const socialLogin = (type, history) => {
  return {
    type: SOCIAL_LOGIN,
    payload: { type, history },
  };
};
